import Page from '../components/Page';
import { useAppStore } from '../stores/useAppStore';

function PageCiscoAiCareers() {
  const { content } = useAppStore();
  return (
    <Page className="pr-[17.875rem] pb-[17.75rem]">

      <div className="pl-[3.5rem] flex flex-row h-full pt-[calc(28rem-var(--header-height))] gap-[11.125rem]">
        <div
          className='flex-shrink-0 w-[49%] h-full bg-cover bg-no-repeat rounded-[3.125rem] overflow-hidden'
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/cisco_ai_careers.jpg)`,
            backgroundPosition: '-52rem center',
          }}
        >
          {/* Imagen de fondo aplicada al contenedor */}
        </div>
        <div className='flex flex-col font-extralight h-full pt-[12rem]'>
            <div className='text-[5.625rem] leading-[8rem] mb-[3.8rem]'>{content.cisco_ai_careers.title}</div>
            <div className='text-[#C7C8D3] text-[2.625rem] leading-[4.25rem] mb-[7rem]' dangerouslySetInnerHTML={{__html:content.cisco_ai_careers.description}}></div>

            <div className='flex items-center'>
                <img className='w-[20rem] h-auto rounded-[1.25rem]'
                    src={`${process.env.PUBLIC_URL}/qr_cisco_ai_careers.png`}
                />
                <div className='font-extralight text-[3.875rem] pl-[5.75rem] pr-[9rem]'>Bring your ideas to a new role.</div>
            </div>
        </div>
      </div>

    </Page>
  );
}

export default PageCiscoAiCareers;